module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'xzv7us05',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production',
  },
}
